import {liteClient} from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import {searchBox, hits, configure, stats} from 'instantsearch.js/es/widgets';
import Ready from '../utils/ready';

Ready(() => {
    let timerId;
    const timeout = 150;
    if (!document.querySelector('#faqs-search-box')) return;

    const searchField = document.querySelector('#faqs-search-box');

    const searchClient = liteClient(
        '0JIZOCPQB1',
        'f446c9efada33fa663a7039c057f610c',
    );

    const searchIndex = 'dev_primary_index';
    const search = instantsearch({
        indexName: searchIndex,
        routing: false,
        searchClient,
        insights: true,
        onStateChange({uiState, setUiState}) {
            setUiState(uiState);
        },
        searchFunction(helper) {
            if (helper.state.query) {
                helper.search();
            }
        },
    });

    const searchPage = '/search/';

    function toggleHitsVisibility(container, isVisible) {
        if (isVisible) {
            document.querySelector(container).classList.remove('hidden');
        } else {
            document.querySelector(container).classList.add('hidden');
        }
    }

    const searchResultsFAQ = (hit, {html}) =>
        html`<div
            class="ais-search-result-link-wrapper"
            data-insights-object-id="${hit.objectID}"
            data-insights-position="${hit.__position}"
            data-insights-query-id="${hit.__queryID}"
        >
            <details class="ais-search-result-body">
                <summary>${hit.title}</summary>
                <div>${html([hit.expanded_content.faq_html])}</div>
            </details>
        </div>`;

    search.addWidgets([
        configure({
            hitsPerPage: 200,
            filters: 'content_type:faq',
            clickAnalytics: true,
        }),
        searchBox({
            container: searchField,
            magnifier: true,
            placeholder: '',
            autofocus: searchPage,
            showReset: true,
            showSubmit: true,
            showLoadingIndicator: true,
            cssClasses: {
                root: 'ais-SearchBox',
                form: 'ais-SearchBox-form',
                input: 'ais-SearchBox-input fui-input',
                submit: 'ais-SearchBox-submit',
                reset: 'ais-SearchBox-reset',
                loadingIcon: 'ais-SearchBox-loading',
            },
            reset() {
                toggleHitsVisibility('#search-box--faqs__hits', 0);
            },
            queryHook(query, refine) {
                clearTimeout(timerId);
                timerId = setTimeout(() => refine(query), timeout);
                toggleHitsVisibility('#search-box--faqs__hits', query.length);
            },
        }),
        stats({
            container: '#search-box--faqs__hits-stats',
        }),
        hits({
            container: '#search-box--faqs__hits',
            templates: {
                empty: 'No questions match your search',
                item: searchResultsFAQ,
            },
        }),
    ]);

    search.start();
    search.refresh();

    const searchBar = document.querySelector('.ais-SearchBox-input');

    const DELAY_AFTER_ANIMATION = 2000;
    const MIN_ANIMATION_DELAY = 30;
    const MAX_ANIMATION_DELAY = 120;

    const PLACEHOLDERS = [
        'eg. is there parking available?',
        'eg. when can visitors come?',
        'eg. what are your opening hours?',
        'eg. do you offer private GP services?',
        'eg. how should I prepare for a surgery?',
        'eg. Do I need a G referral?',
        'eg. How long does a private consultation last?',
        'eg. Can I listen to music in theatre?',
    ];

    const getRandomDelayBetween = (min, max) =>
        Math.floor(Math.random() * (max - min + 1) + min);

    const setPlaceholder = (inputNode, placeholder) => {
        inputNode.setAttribute('placeholder', placeholder);
    };

    const animateLetters = (currentLetters, remainingLetters, inputNode) => {
        if (!remainingLetters.length) {
            return (
                typeof onAnimationEnd === 'function' &&
                onAnimationEnd(currentLetters.join(''), inputNode)
            );
        }

        currentLetters.push(remainingLetters.shift());

        setTimeout(
            () => {
                setPlaceholder(inputNode, currentLetters.join(''));
                animateLetters(currentLetters, remainingLetters, inputNode);
            },
            getRandomDelayBetween(MIN_ANIMATION_DELAY, MAX_ANIMATION_DELAY),
        );
    };

    const animatePlaceholder = (inputNode, placeholder) => {
        animateLetters([], placeholder.split(''), inputNode);
    };

    const onAnimationEnd = (placeholder, inputNode) => {
        setTimeout(() => {
            let newPlaceholder = '';

            do {
                newPlaceholder =
                    PLACEHOLDERS[
                        Math.floor(Math.random() * PLACEHOLDERS.length)
                    ];
            } while (placeholder === newPlaceholder);

            animatePlaceholder(inputNode, newPlaceholder, onAnimationEnd);
        }, DELAY_AFTER_ANIMATION);
    };

    window.addEventListener('load', () => {
        // If we want multiple, different placeholders, we pass our callback.
        animatePlaceholder(searchBar, PLACEHOLDERS[0], onAnimationEnd);
    });
});
